import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import history from '~/services/history';
import api from '~/services/api';
import * as actions from './actions';
import * as types from './types';

/**
 * ---------------------------------------------------
 *  GET INSTITUIÇÕES PARTICIPANTES
 * ---------------------------------------------------
 */

export function* getUsers({ payload }) {
  const { orderBy = '', offset = '', search = '', direction = 'asc' } = payload;
  const order = orderBy || '';
  const filter = search || '';

  try {
    const response = yield call(
      api.get,
      `usuarios?limit=5${filter && `&filter=${filter}`}&offset=${offset ||
        0}${order && `&orderBy=${order}&direction=${direction}`}`
    );

    const totalCount = response.headers['total-count'];

    yield put(
      actions.getUsersSuccess({
        usersData: {
          data: response.data,
          totalCount,
        },
        usersOrderBy: order,
        usersSearch: filter,
      })
    );
  } catch (error) {
    yield put(actions.getUsersFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `${token}`;
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest(types.GET_USERS_REQUEST, getUsers),
]);
